import apiService from './api.service'

const getInfoUnificarPessoa = (oids, pessoaFisica = true) => {
  if (pessoaFisica) {
    return apiService.post(`/lottustech/pessoasfisicas/unificar/info`, oids)
  }
  return apiService.post(`/lottustech/pessoasjuridicas/unificar/info`, oids)
}

const unificarPessoaFisica = (oidPessoaManter, oidsPessoasRemover) => {
  return apiService.post(`/lottustech/pessoasfisicas/unificar`, {
    oidManter: oidPessoaManter,
    oidsRemover: oidsPessoasRemover,
  })
}

const unificarPessoaJuridica = (oidPessoaManter, oidsPessoasRemover) => {
  return apiService.post(`/lottustech/pessoasjuridicas/unificar`, {
    oidManter: oidPessoaManter,
    oidsRemover: oidsPessoasRemover,
  })
}

export { getInfoUnificarPessoa, unificarPessoaFisica, unificarPessoaJuridica }
